import { index, uniqueIndex, sql, customIndex } from '@w/db'
import { sqliteTable } from '@w/db/sqlite'
import { s } from '@w/schema'

export const pages = sqliteTable({
  columns: c => ({
    workspaceId:c.ulid().notNull(), id:c.text().notNull(), updatedAt:c.integer().notNull(),
    deletedAt:c.integer(),deletedBy:c.text(),
    inheritance:c.text().notNull().default('inherit').$type<'inherit'|'restricted'>(),
    kind:c.text().notNull().default('note'),
  }),
  primaryKey: t => [t.workspaceId,t.id], indexes: t => [index(t.workspaceId,t.id,t.inheritance,t.deletedAt)], fn: () => ({ secure: () => true }),
})
export const pagePermissions = sqliteTable({
  columns: c => ({ workspaceId: c.ulid().notNull(), pageId: c.text().notNull(), principalKind: c.text().notNull().$type<'user'>(), principalId: c.ulid().notNull(), level: c.integer().notNull() }),
  indexes: t => [uniqueIndex(t.workspaceId, t.pageId, t.principalKind, t.principalId), index(t.workspaceId,t.principalKind,t.principalId,t.pageId,t.level)], fn: () => ({ secure: () => true }),
})
export const pageRelations = sqliteTable({
  columns: c => ({ workspaceId: c.ulid().notNull(), fromPageId: c.text().notNull(), toPageId: c.text().notNull(), targetSpaces: c.text().notNull().default('::'), type: c.custom("TEXT CHECK(type IN ('child','link'))", s.enum(['child','link'])).notNull(), node: c.text().notNull().default('') }),
  primaryKey: t => [t.workspaceId,t.fromPageId,t.toPageId,t.type,t.node],
  indexes: t => [index(t.workspaceId, t.toPageId, t.type), index(t.workspaceId, t.fromPageId, t.type), customIndex({ name: 'idx_pageRelations_single_child', on: [t.workspaceId,t.toPageId], unique: true, where: sql.raw`type='child'` })],
  fn: () => ({ secure: () => true }),
})
export const productTables = { pages, pagePermissions, pageRelations }
